import { API_BASE } from './config';

// Sliders
export const getSliders = async () => {
  const res = await fetch(`${API_BASE}/sliders.php`);
  return res.json();
};

// Services
export const getServices = async () => {
  const res = await fetch(`${API_BASE}/services.php`);
  return res.json();
};

export const getServiceBySlug = async (slug) => {
  const res = await fetch(`${API_BASE}/services.php?slug=${slug}`);
  return res.json();
};

// Projects
export const getProjects = async () => {
  const res = await fetch(`${API_BASE}/projects.php`);
  return res.json();
};

export const getFeaturedProjects = async () => {
  const res = await fetch(`${API_BASE}/projects.php?featured=1`);
  return res.json();
};

export const getProjectBySlug = async (slug) => {
  const res = await fetch(`${API_BASE}/projects.php?slug=${slug}`);
  return res.json();
};

export const getProjectsByCategory = async (category) => {
  const res = await fetch(`${API_BASE}/projects.php?category=${category}`);
  return res.json();
};

// Products
export const getProducts = async () => {
  const res = await fetch(`${API_BASE}/products.php`);
  return res.json();
};

export const getFeaturedProducts = async () => {
  const res = await fetch(`${API_BASE}/products.php?featured=1`);
  return res.json();
};

export const getProductBySlug = async (slug) => {
  const res = await fetch(`${API_BASE}/products.php?slug=${slug}`);
  return res.json();
};

export const getProductsByCategory = async (category) => {
  const res = await fetch(`${API_BASE}/products.php?category=${category}`);
  return res.json();
};

// Gallery
export const getGallery = async () => {
  const res = await fetch(`${API_BASE}/gallery.php`);
  return res.json();
};

export const getGalleryByCategory = async (category) => {
  const res = await fetch(`${API_BASE}/gallery.php?category=${category}`);
  return res.json();
};

export const getGalleryByType = async (type) => {
  const res = await fetch(`${API_BASE}/gallery.php?type=${type}`);
  return res.json();
};

// Clients
export const getClients = async () => {
  const res = await fetch(`${API_BASE}/clients.php`);
  return res.json();
};

// Testimonials
export const getTestimonials = async () => {
  const res = await fetch(`${API_BASE}/testimonials.php`);
  return res.json();
};

// Pages
export const getPage = async (key) => {
  const res = await fetch(`${API_BASE}/pages.php?key=${key}`);
  return res.json();
};

// Settings
export const getSettings = async () => {
  const res = await fetch(`${API_BASE}/settings.php`);
  return res.json();
};

// Client image gallery (public, read-only)
export const getClientImages = async (clientId) => {
  const res = await fetch(`${API_BASE}/client_images.php?client_id=${clientId}`);
  return res.json();
};

// Inquiry
export const submitInquiry = async (data) => {
  const res = await fetch(`${API_BASE}/inquiry.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return res.json();
};